import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

/**
 * ErrorBoundary global — captura errores no manejados en cualquier página
 * y muestra pantalla amable en lugar de blanco vacío.
 * Persiste stack trace en console para debugging.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary capturó un error:", error, errorInfo);
    this.setState({ errorInfo });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = "/ordenes";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6" data-testid="error-boundary">
          <div className="max-w-lg bg-white rounded-lg shadow-md border border-red-200 p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
                <AlertTriangle className="w-5 h-5 text-red-600" />
              </div>
              <div>
                <h1 className="text-lg font-bold text-slate-900">Algo salió mal</h1>
                <p className="text-xs text-slate-500">Alfa-Field Connect encontró un error inesperado</p>
              </div>
            </div>
            <p className="text-sm text-slate-700 mb-4">
              La pantalla no pudo cargarse correctamente. Puedes intentar recargar o volver al inicio.
            </p>
            {this.state.error && (
              <details className="mb-4">
                <summary className="text-xs text-slate-500 cursor-pointer hover:text-slate-700">
                  Detalles técnicos
                </summary>
                <pre className="mt-2 text-[10px] font-mono bg-slate-100 p-2 rounded overflow-x-auto max-h-40">
                  {this.state.error.toString()}
                  {this.state.errorInfo?.componentStack?.slice(0, 500)}
                </pre>
              </details>
            )}
            <div className="flex gap-2">
              <button
                onClick={this.handleReset}
                className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-[#0A3747] hover:bg-[#135166] text-white text-sm rounded-md"
                data-testid="error-reload-btn"
              >
                <RefreshCw className="w-4 h-4" /> Recargar página
              </button>
              <button
                onClick={this.handleGoHome}
                className="flex-1 px-4 py-2 border border-slate-300 hover:bg-slate-50 text-sm rounded-md"
                data-testid="error-home-btn"
              >
                Volver al inicio
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
